import $axios from '@/plugins/axios-instance'

export default {
    state: {

    },
    actions: {
        saveLogin(context, data) {
            return $axios.post('/Profile/saveLogin', {
                login: data
            })
            .then((response) => {
                return response.data
            }).catch((e)=>{
                throw(e.response)
            })
        },

        changePassword(context, data) {
            return $axios.post('/Profile/ChangePassword', data)
            .then((response) => {
                return response.data
            }).catch((e)=>{
                throw(e.response)
            })
        },

        getProfileInfo(context, data) {
            return  $axios.get('/Profile/GetProfileInfo')
            .then((response) => {
                return response.data
            }).catch((e)=>{
                throw(e.response)
            })
        },

        sendConfirmLogin(context, data) {
            return $axios.post('/Profile/SendConfirmLogin', {
                login: data
            })
            .then((response) => {
                return response.data
            }).catch((e)=>{
                throw(e.response)
            })
        },
        
        changeLogin(context, data) {
            return $axios.post('/Profile/changeLogin', data)
            .then((response) => {
                return response.data
            }).catch((e)=>{
                throw(e.response)
            })
        },

        changePassword(context, data) {
            return $axios.post('/Profile/ChangePassword', data)
            .then((response) => {
                return response.data
            }).catch((e)=>{
                throw(e.response)
            })
        },
        
        confirmPhoneNumber(context, data) {
            return $axios.post('/Profile/ConfirmPhoneNumber', data)
            .then((response) => {
                return response.data
            }).catch((e)=>{
                throw(e.response)
            })
        },

        profileSaveLogin(context, data) {
            return $axios.post(`/Profile/SaveLogin?login=${data}`)
            .then((response) => {
                return response.data
            }).catch((e)=>{
                throw(e.response)
            })
        },
        
        logout () {
			return $axios.post(`/Profile/logout`)
			.then(() => {
				return true
			}).catch((e)=>{
				throw(e)
			})
		}
    }
}